export const judgeRegNumTyp = (inputNum) => {
  let result;
  let num = '' + inputNum;
  //remove hyphen
  // num = removeHyphen(num)
  num = num.replace(/-/g, '');
  if (num.length === 13) {
    const tail = inputNum.slice(6);
    //외국인번호
    if (tail[0] === 5 || tail[0] === 6 || tail[0] === 7 || tail[0] === 8) {
      result = '03';
    }
    //주민번호
    else {
      result = '02';
    }
  }
  //사업자번호
  else {
    result = '01';
  }
  return result;
};